import { render, staticRenderFns } from "./PhyDiagRecord2.vue?vue&type=template&id=778b5385&scoped=true"
import script from "./PhyDiagRecord2.vue?vue&type=script&lang=js"
export * from "./PhyDiagRecord2.vue?vue&type=script&lang=js"
import style0 from "./PhyDiagRecord2.vue?vue&type=style&index=0&id=778b5385&lang=scss"
import style1 from "./PhyDiagRecord2.vue?vue&type=style&index=1&id=778b5385&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778b5385",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('778b5385')) {
      api.createRecord('778b5385', component.options)
    } else {
      api.reload('778b5385', component.options)
    }
    module.hot.accept("./PhyDiagRecord2.vue?vue&type=template&id=778b5385&scoped=true", function () {
      api.rerender('778b5385', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PhyDiagRecord2.vue"
export default component.exports